import get from 'lodash/get';
import { createSelector } from 'reselect';

export const selectRootState = state =>
  get(state, 'paperwork.paperworkVerifyDob');

export const selectPaperworkVerifyDobPending = createSelector(
  selectRootState,
  state => get(state, 'sending', false),
);

export const selectPaperworkVerifyDobError = createSelector(
  selectRootState,
  state => get(state, 'error'),
);



// WEBPACK FOOTER //
// ./src/redux/paperwork/selectors/paperwork-verify-dob.js